import React, { memo, useCallback, useEffect } from "react";
import { placeholder, XMarkIcon } from "@";

const ImageLargePreview = ({ image, hide, url }) => {
  const handleHide = useCallback(() => {
    hide();
  }, [hide]);

  // Close on Escape + lock body scroll
  useEffect(() => {
    if (!image) return;
    const handleKey = (e) => {
      if (e.key === "Escape") handleHide();
    };
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [image, handleHide]);

  if (!image) return null;

  return (
    <div
      onClick={handleHide}
      className="fixed inset-0 z-[999] flex cursor-zoom-out items-start justify-center bg-black/85 pt-5 backdrop-blur-md"
    >
      {/* Close button — fixed top */}
      <button
        type="button"
        onClick={handleHide}
        aria-label="إغلاق"
        className="absolute end-5 top-5 z-10 inline-flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border border-white/15 bg-white/10 text-white backdrop-blur-md transition-all duration-200 hover:rotate-90 hover:bg-white/20 active:scale-95"
      >
        <XMarkIcon className="h-5 w-5" />
      </button>

      <div
        onClick={(e) => e.stopPropagation()}
        className="relative h-80 w-fit max-w-[calc(90%)] cursor-default overflow-hidden rounded-2xl ring-1 ring-white/10 md:h-[600px] 2xl:h-[800px]"
      >
        <img
          alt="image preview"
          loading="lazy"
          className="mx-auto h-full w-full rounded-2xl object-contain"
          src={url ? url : placeholder}
        />
      </div>
    </div>
  );
};

export default memo(ImageLargePreview);
